import React from "react";
import {defineBlock, ChildrenBlock, useEditor, smartProps, EditableImg, useSmartProp, useInspectorControl} from "@smartfire/wordpress-react";
import { InnerBlocks } from '@wordpress/block-editor';
import { PanelBody, PanelRow, ToggleControl, SelectControl } from '@wordpress/components';
import {PictoLibelle} from '../shared/pictoLibelle';
import style from './block.module.scss';
import classnames from 'classnames'


function Inspector(){
    const [losangeStyle, setLosangeStyle] = useSmartProp("losangeStyle");
    const [losangeMiroir, setLosangeMiroir] = useSmartProp("losangeMiroir");

    return <> 
        <PanelBody title="Losange" initialOpen={true}>
            <PanelRow>
                <SelectControl
                    value={losangeStyle}
                    onChange={(value) =>setLosangeStyle(value)}
                    options={ [
                        { value: 'none', label: 'Aucun' },
                        { value: 'small', label: 'Petit' },
                        { value: 'large', label: 'Grand' },
                    ] }
                />
            </PanelRow>
            <PanelRow>
                <ToggleControl
                    label={losangeMiroir ? 'Droite' : 'Gauche'}
                    checked={losangeMiroir}
                    onChange={setLosangeMiroir}
                />
            </PanelRow>
        </PanelBody></>
}

function Block ({svgLibelle, svgLibelle2, losangeStyle, losangeMiroir}) {

    const {isEditing} = useEditor();
    useInspectorControl(Inspector);

    var losangeClasses = classnames({
        [style.losange]: true,
        [style.none]: losangeStyle === 'none',
        [style.small]: losangeStyle === 'small',
        [style.large]: losangeStyle === 'large',
        [style.right]: losangeMiroir
    })

    return <div className={style.block}>
        <div className={losangeClasses}></div>
        <div className={style.container}>
            <div className={style.col1}>
                {isEditing ? 
                <InnerBlocks allowedBlocks={[ 'core/heading', 'core/paragraph', 'core/bold', 'core/image', 'core/list', 'core/gallery', 'core/separator', 'smartfire/smart-button', 'smartfire/spacer' ]} />:
                <ChildrenBlock />}
            </div>
            <div className={style.col2}>
                <EditableImg className={style.img} smartProp="img"/>
            </div>
        </div>
        <div className={style.containerPictos}>
            <PictoLibelle smartProp="svgLibelle" svgLibelle={svgLibelle} />
        </div>
    </div>
}

export default defineBlock({
    Block,
    smartProps: {
        img: smartProps.any.withDefault(),
        svgLibelle: smartProps.any.withDefault([
            {
                picture: "",
                libelle: "libelle"
            }
        ]),
        losangeStyle: smartProps.string.withDefault('none'),
        losangeMiroir: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Offre',
    }
});